import React from 'react'
import EHRCaseStudyHero from './EHRCaseStudyHero'
import CallToAction from '../../../../LandingSection/CallToAction'
import Footer from '../../../../Components/Footer'
import Header from '../../../../Components/Header'
import Challenge from './Challenge'
import OurSolution from './OurSolution'
import EHRTechSolutions from './EHRTechSolutions'

const EHRCaseStudyPage = () => {
  return (
    <>
      <Header bgColor="#121212"/>
      <EHRCaseStudyHero />
      <EHRTechSolutions />
      <Challenge />
      <OurSolution />
      <CallToAction/>
      <Footer/>
    </>
  )
}

export default EHRCaseStudyPage
